const awsmobile = {
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    userPoolWebClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID,
    userPoolId: process.env.VUE_APP_AWS_USER_POOL_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
};
export default awsmobile;
